export default __webpack_public_path__ + "static/media/carson-project-3.1fc499d3.webp";